<ng-container *transloco="let translate; read: 'notifications'">
    <div class="relative flex w-full max-w-sm overflow-hidden bg-card rounded-xl shadow-xl hover:shadow-2xl ring-1 ring-black/5 dark:ring-white/10 cursor-pointer hover:bg-hover active:bg-hover dark:bg-gray-800 pointer-events-auto transition-all duration-300"
        (click)="onNotificationClick()">

        <!-- Left color accent line -->
        <div class="absolute left-0 top-0 bottom-0 w-1.5" [class]="iconConfig.borderClass"></div>

        <!-- Left color accent/icon -->
        <div class="flex items-start justify-center pl-5 pr-3 py-4">
            <div class="flex items-center justify-center rounded-full p-2" [class]="iconConfig.bgClass">
                <mat-icon class="icon-size-6" [class]="iconConfig.textClass" [svgIcon]="iconConfig.icon"></mat-icon>
            </div>
        </div>

        <!-- Content -->
        <div class="py-4 pr-10 grow min-w-0 flex flex-col justify-center">
            <div class="flex items-center justify-between mb-0.5">
                <span class="font-semibold text-sm text-gray-900 dark:text-gray-100 truncate pr-2 w-full">
                    {{ notification.title }}
                </span>
                <span class="text-xs font-medium text-gray-500 dark:text-gray-400 whitespace-nowrap ml-2">
                    {{ translate('just_now') || 'Just now' }}
                </span>
            </div>
            <p class="text-sm text-gray-500 dark:text-gray-400 line-clamp-2 leading-relaxed">
                {{ notification.message }}
            </p>
        </div>

        <!-- Close button / right edge -->
        <div class="absolute right-2 top-3">
            <button mat-icon-button (click)="closeTask($event)"
                class="w-7 h-7 min-h-7 opacity-50 hover:opacity-100 transition-opacity">
                <mat-icon class="icon-size-4" svgIcon="heroicons_outline:x-mark"></mat-icon>
            </button>
        </div>
    </div>
</ng-container>